<template>
    <div class="ShopList">
        <div></div>
    </div>
</template>

<script>
export default {
    name: 'ShopList',
    data() {
        return {
        }
    },
    mounted() {
    },
    methods: {
    },
    filters: {},
    watch: {},
    computed: {},
    components: {
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .ShopList {
    }
</style>
